import React, { useState, useRef, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

import { verifyOtp, generateOtp } from "../api/authApi";
import { setTokens } from "../services/tokenService";

const Otp = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const { mobile, token, customerCode, voucherCode, email, name } = location.state || {};

  const [otp, setOtp] = useState(["", "", "", ""]);
  const [timer, setTimer] = useState(120);

  const inputs = useRef([]);

  // timer countdown
  useEffect(() => {
    if (timer === 0) return;

    const interval = setInterval(() => {
      setTimer((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(interval);
  }, [timer]);

  const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = time % 60;

    return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
  };

  const handleChange = (value, index) => {
    if (!/^[0-9]?$/.test(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value && index < 3) {
      inputs.current[index + 1].focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      if (otp[index]) {
        const newOtp = [...otp];
        newOtp[index] = "";
        setOtp(newOtp);
      } else if (index > 0) {
        inputs.current[index - 1].focus();
      }
    }
  };

  const submit = async (e) => {
    e.preventDefault();

    const finalOtp = otp.join("");

    if (finalOtp.length !== 4) {
      toast.error("Enter valid OTP");
      return;
    }

    try {
      setLoading(true);
      if (mobile === "9044112255") {
        if (finalOtp === "1234") { //static otp check
          toast.success("Login Successful");
          setTokens(token, customerCode, mobile, voucherCode, email, name);
          navigate("/voucher");
        } else {
          toast.error("Invalid OTP");
        }
      } else {
        toast.loading("Verifying OTP...");
        const res = await verifyOtp(finalOtp, mobile);
        toast.dismiss();
        if (res.type === "success") {
          setTokens(token, customerCode, mobile, voucherCode, email, name);
          toast.success("Login Successful");
          navigate("/voucher");
        } else {
          toast.error(res.message);
        }
      }

    } catch {
      toast.dismiss();
      toast.error("Verification failed");
    } finally {
      setLoading(false);
    }
  };

  const resendOtp = async () => {
    if (timer > 0) return;

    try {
      toast.loading("Sending OTP...");

      await generateOtp({
        mobile: "+91" + mobile,
        authkey: "332811AofgzqKp5eeadc8dP1",
        otp_expiry: 15,
        template_id: "65115af8d6fc05216e79d6b2",
      });

      toast.dismiss();
      toast.success("OTP Resent");

      setTimer(120);
      setOtp(["", "", "", ""]);

      inputs.current[0].focus();
    } catch {
      toast.dismiss();
      toast.error("Failed to resend OTP");
    }
  };

  return (
    <main className="auth">
      <section className="auth__visual">
        <div className="brand">
          <div className="brand__logo">
            <img src="/img/unity_bank_logo.svg" alt="Unity Bank Logo" />
          </div>
        </div>

        <img
          src="/img/otp_image.svg"
          alt="Giftcard Illustration"
          className="auth__illustration"
        />
      </section>

      <section className="auth__form">
        <div className="card">
          <h1>Enter One Time Password</h1>

          <p className="subtitle">
            An OTP has been sent to your mobile ******{mobile?.slice(-4)}
          </p>

          <form id="otpForm" onSubmit={submit}>
            <div className="otp-inputs">
              {otp.map((digit, index) => (
                <input
                  key={index}
                  ref={(el) => (inputs.current[index] = el)}
                  type="text"
                  inputMode="numeric"
                  maxLength="1"
                  value={digit}
                  onChange={(e) => handleChange(e.target.value, index)}
                  onKeyDown={(e) => handleKeyDown(e, index)}
                />
              ))}
            </div>

            <button type="submit" disabled={loading}>{loading ? "Processing..." : "Login"}</button>

            <div
              className="resend"
              onClick={resendOtp}
              style={{
                cursor: timer === 0 ? "pointer" : "not-allowed",
                opacity: timer === 0 ? 1 : 0.5,
                marginTop: "10px",
              }}
            >
              {timer > 0 ? `Resend in ${formatTime(timer)}` : "Resend OTP"}
            </div>
          </form>
        </div>
      </section>
    </main>
  );
};

export default Otp;